const components = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        fontSize: 14,
        height: 'auto',
        color: 'inherit',
        backgroundColor: 'inherit',
        borderRadius: '0 !important',
        boxShadow: 'none',
        margin: '0 !important',
        '&:not(:last-child)': {
          borderBottom: 0
        },
        '&:before': {
          display: 'none'
        },
        '&$expanded': {
          margin: 'auto'
        }
      }
    }
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: '0 0 16px 0'
      }
    }
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: 0,
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
          minHeight: 56
        }
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        height: 40,
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      },
      contained: {
        height: 40,
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: '#38424a',
        '&.normal': {
          fontWeight: 100
        },
        '&.bold': {
          fontWeight: 600
        },
        '&.semi-bold': {
          fontWeight: 400
        }
      },
      body1: {
        fontWeight: 100
      }
    }
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(140, 130, 121, 0.1)',
        borderRadius: '4px',
        minHeight: '30px',
        padding: '5px'
      },
      flexContainer: {
        height: '100%'
      },
      indicator: {
        display: 'none'
      },
      scrollButtons: {
        width: '20px'
      },
      scrollButtonsDesktop: {
        display: 'flex !important'
      },
      scrollable: {
        height: '100%',
        '-ms-overflow-style': 'none'
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        display: 'flex',
        flex: '1 1 0px',
        fontWeight: 600,
        justifyContent: 'center',
        minHeight: '30px',
        maxWidth: '275px',
        padding: '0 !important',
        textTransform: 'capitalize',
        '&.Mui-selected': {
          background: '#ffffff !important',
          boxShadow: '0 2px 9px 0 rgba(0, 0, 0, 0.03)',
          borderRadius: '4px',
          color: '#3399ff'
        },
        '@media (max-width: 999px)': {
          minWidth: '120px'
        },
        '@media (min-width: 1000px)': {
          minWidth: 'auto !important'
        }
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        margin: '15px 0 0 5px !important',
        padding: '0 !important',
        '&.Mui-selected': {
          boxShadow: '0px 0px 5px 1px #3399ff !important'
        }
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: 'rgba(56, 66, 74, 0.85)'
      },
      arrow: {
        color: 'rgba(56, 66, 74, 0.85)'
      }
    }
  }
}

export default components
